import React from 'react';
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";

import {CardContainer, Input, Button, Tab} from 'components/common/uiKit';
import {NoRecord} from 'components/common/app';


class SubLesson extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lessonId: props.lessonId,
            data: props.childs
        }
    }

    handleLink = id => {
        const {history} = this.props;
        history.push({
            pathname: `lesson?lessonId=${id}`,
            //search: `?lessonId=${id}`,
            //state: {...data}
        });
    };

    render() {
        const {lessonId, data} = this.state;


        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.Lesson.Main;

        if (!data || data.length == 0)
            return (<NoRecord message='SubLesson'/>);

        return (
            <CardContainer>
                <div className="list-group list-custom-small">
                    {data.map((item, index) => {
                        const number = index + 1;
                        const {title} = item;
                        return (
                            <Link onClick={this.handleLink.bind(this, item.id)}>
                                <i className='rounded-sm shadow-xl bg-primary' style={{fontStyle: 'normal'}}>
                                    {number}
                                </i>
                                <span className='float-right'>
                                    {title}
                                </span>
                                <i className="fa fa-angle-left"></i>
                            </Link>
                        );
                    })}
                </div>
            </CardContainer>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(SubLesson));